module.exports = __webpack_public_path__ + "img/product-icon_6.da6652c2.png";